import dateToStandart from './dateToStandart';

const today = new Date();

function initDay (date:number = 0):string {
    return new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate() - date)).toISOString()
}

function defaultDate(days:number = 7, timeDate:boolean = true):{start:string, end: string}|void {
    return {
        start: dateToStandart(initDay(days), timeDate),
        end: dateToStandart(initDay(), timeDate)
    }
}

export default defaultDate;